import { NgClass, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'curbnturf-map-icons',
  templateUrl: './map-icons.component.html',
  styleUrls: ['./map-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, NgSwitch, NgSwitchCase],
})
export class MapIconsComponent implements OnChanges {
  @Input() type: string;
  @Input() opacity = 1;
  @Input() white = false;
  @Input() green = false;
  @Input() primary = false;
  @Input() pin = false;
  @Input() filledPin = false;
  @Input() solidPin = false;
  @Input() string = '';

  classes = 'primary';
  color = '#e3530d';

  ngOnChanges() {
    this.color = this.white ? '#fff' : this.green ? '#465d50' : this.primary ? '#e3530d' : '#454545';
    this.classes = this.white ? 'white' : this.green ? 'green' : this.primary ? 'primary' : 'secondary';
  }
}
